import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../common/helpers/helpers";

const EvidenceColumn = ({
  evidenceUrl,
  evidenceType,
  evidenceLevel,
  evidenceStatus,
  evidenceDirection,
}) => {
  return (
    <div>
      {evidenceType && (
        <>
          {evidenceUrl ? (
            <a target="_blank" href={getVarsoUrl(evidenceUrl)}>
              {evidenceType}
            </a>
          ) : (
            <span>{evidenceType}</span>
          )}
        </>
      )}
      <small>
        {evidenceLevel && (
          <div className="tw-mb-0.5">{`Level: ${evidenceLevel}`}</div>
        )}
        {evidenceStatus && (
          <div className="tw-mb-0.5">{`Status: ${evidenceStatus}`}</div>
        )}
        {evidenceDirection && (
          <div className="tw-mb-0.5">{`Direction: ${evidenceDirection}`}</div>
        )}
      </small>
    </div>
  );
};

EvidenceColumn.propTypes = {
  evidenceUrl: PropTypes.string,
  evidenceType: PropTypes.string,
  evidenceLevel: PropTypes.string,
  evidenceStatus: PropTypes.string,
  evidenceDirection: PropTypes.string,
};

EvidenceColumn.defaultProps = {
  evidenceUrl: "",
  evidenceType: "",
  evidenceLevel: "",
  evidenceStatus: "",
  evidenceDirection: "",
};

export default EvidenceColumn;
